import PropTypes from "prop-types";

export const SubCategoriesIcon = ({ active, ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="23"
      fill="none"
      viewBox="0 0 22 23">
      <path
        stroke={active ? "#0071BC" : "#455A64"}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.2"
        d="M18.455 1.57h-4.444a2.222 2.222 0 00-2.222 2.223v13.333a4.445 4.445 0 108.888 0V3.793a2.222 2.222 0 00-2.222-2.223z"></path>
      <path
        stroke={active ? "#0071BC" : "#455A64"}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.2"
        d="M11.783 6.4L9.561 4.178a2.222 2.222 0 00-3.142 0L3.278 7.32a2.222 2.222 0 000 3.142l9.998 10"></path>
      <path
        stroke={active ? "#0071BC" : "#455A64"}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.2"
        d="M5.453 12.68H2.898a2.222 2.222 0 00-2.222 2.222v4.444a2.222 2.222 0 002.222 2.223H16.23M16.23 17.129v.011"></path>
    </svg>
  );
};

SubCategoriesIcon.propTypes = {
  active: PropTypes.bool
};
